import "../_namespaces.js";
import "../models/completion_page.js";

window.AssessmentViewer ??= {};
window.AssessmentViewer.Collections ??= {};

AssessmentViewer.Collections.CompletionPages = class CompletionPages extends Backbone.Collection {};
AssessmentViewer.Collections.CompletionPages.prototype.model = AssessmentViewer.Models.CompletionPage;
